import { SSO_META } from "config";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { api, ui } from "services";
import crypt from "services/crypt";

export default function GameLinkEmailPage() {
  const { token } = useParams();

  useEffect(() => {
    crypt.verifyJwt(token).then(data => {
      if (data.password) {
        api.linkWithEmailToken(token).then(() => {
          window.open(SSO_META().GameLink, "_self");
          return;
        }).catch((err) => {
          ui.alertFailed('Your token is invalid !', 'Please try again later !')
        });
      }
    }).catch(err => {
      console.log({ err })
      ui.alertFailed('Your token is invalid !', 'Please try again later !')
    })
  }, [])


  return (
    <div className="w-full dao-container">
    </div >
  )
}
